import { useSyncExternalStore } from "react";

/**
 * Width alone misclassifies touch devices: an iPad, a landscape phone, or a
 * phone with Safari's "Request Desktop Website" on all report a viewport at
 * or above antd's `md` breakpoint. The primary pointer is what actually
 * separates a desk from a hand-held screen, so layouts that go fullscreen on
 * phones should also do so whenever it is coarse.
 */
const COARSE_POINTER_QUERY = "(pointer: coarse)";

const subscribe = (onChange: () => void) => {
  const mediaQuery = window.matchMedia(COARSE_POINTER_QUERY);
  mediaQuery.addEventListener("change", onChange);
  return () => mediaQuery.removeEventListener("change", onChange);
};

const getSnapshot = () => window.matchMedia(COARSE_POINTER_QUERY).matches;

// Server render has no pointer; the client corrects this before paint.
const getServerSnapshot = () => false;

/** True when the device's primary pointer is touch (`pointer: coarse`). */
const useCoarsePointer = () =>
  useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

export default useCoarsePointer;
